import { render, staticRenderFns } from "./CommonAside.vue?vue&type=template&id=04955eb0&"
import script from "./CommonAside.vue?vue&type=script&lang=js&"
export * from "./CommonAside.vue?vue&type=script&lang=js&"
import style0 from "./CommonAside.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04955eb0')) {
      api.createRecord('04955eb0', component.options)
    } else {
      api.reload('04955eb0', component.options)
    }
    module.hot.accept("./CommonAside.vue?vue&type=template&id=04955eb0&", function () {
      api.rerender('04955eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/CommonAside.vue"
export default component.exports